{
  "nav": {
    "account": "Account",
    "preferences": "Preferences",
    "paymentMethods": "Payment Methods",
    "andeRewards": "Ande Rewards",
    "rewards": "Rewards",
    "hospitalityRewards": "Hospitality Rewards",
    "referrals": "Referrals"
  },
  "avatarModal": {
    "title": "Update Profile Picture",
    "preview": "Preview",
    "dragHint": "Drag the image to adjust its position",
    "change": "Change",
    "cancel": "Cancel",
    "save": "Save"
  },
  "notifications": {
    "profilePictureUpdated": {
      "title": "Profile picture updated",
      "body": "Your profile picture was successfully updated"
    },
    "preferencesSaved": {
      "title": "Account Preferences Saved",
      "body": "Your account preferences have been saved successfully."
    },
    "preferencesSaveFailed": {
      "title": "An Error Occurred",
      "body": "We were unable to save your account preferences. Please try again later."
    },
    "accountUpdated": {
      "title": "Account settings updated",
      "body": "Your account settings were successfully updated."
    },
    "success": {
      "title": "Success"
    },
    "error": {
      "title": "An Error Occurred"
    }
  },
  "preferences": {
    "dietaryRestrictions": {
      "heading": "Dietary Restrictions",
      "searchLabel": "Search for Dietary Restrictions",
      "allSelected": "All restrictions selected",
      "additionalNotesLabel": "Additional Dietary Notes",
      "helperText": "Requests you include here will be added to every reservation and venues will do their best to accommodate them."
    },
    "dateTime": {
      "heading": "Date & time",
      "description": "Choose how dates and system timestamps appear.",
      "useDeviceSettings": "Use device settings",
      "regionFormatLabel": "Region format",
      "timeZoneLabel": "Time zone",
      "previewLabel": "Preview"
    },
    "notifications": {
      "heading": "Notification Preferences"
    },
    "actions": {
      "saveChanges": "Save Changes",
      "saving": "Saving..."
    }
  },
  "notificationPreferences": {
    "channels": {
      "email": "Email",
      "push": "Mobile",
      "sms": "SMS"
    },
    "emailFrequency": "Email frequency",
    "notifyVia": "Notify me via:",
    "planningDigest": {
      "daily": "Daily",
      "weekly": "Weekly",
      "none": "None"
    },
    "eventUpdates": {
      "cadenceDescription": "We'll email you based on how soon each event is.",
      "cadenceRows": {
        "withinTwoWeeks": "Less than 2 weeks away",
        "twoWeeksToTwoMonths": "2 weeks to 2 months away",
        "twoPlusMonths": "More than 2 months away"
      },
      "cadenceOptions": {
        "instantly": "As they happen",
        "daily": "Daily summary",
        "weekly": "Weekly summary"
      }
    }
  },
  "accountTab": {
    "phoneNumberLabel": "Phone Number",
    "betaFeatures": {
      "title": "Enable Beta Features",
      "description": "Turn this on to opt in to the newest features in the app."
    },
    "actions": {
      "saveChanges": "Save Changes",
      "saving": "Saving..."
    }
  },
  "paymentMethods": {
    "pageTitle": "Payment methods",
    "addPaymentMethod": "Add Payment Method",
    "sections": {
      "corporate": "Corporate",
      "personal": "Personal"
    },
    "card": {
      "default": "Default",
      "brandAlt": "Card"
    },
    "menu": {
      "setAsDefault": "Set as Default",
      "delete": "Delete"
    },
    "deleteModal": {
      "cannotDeleteTitle": "Can't delete this method",
      "deleteTitle": "Delete Payment Method",
      "ok": "OK",
      "keepCard": "Keep Card",
      "deleting": "Deleting...",
      "inUseBody": "This card is being used as the card on file for some on going reservations and cannot be deleted.",
      "confirmBody": "This action cannot be undone."
    },
    "fetchError": {
      "message": "There was an error trying to fetch your available cards.\nPlease try reloading them.",
      "reload": "Reload Card List"
    },
    "modal": {
      "addTitle": "Add New Payment Method",
      "creating": "Creating...",
      "continue": "Continue",
      "saveCard": "Save Card",
      "saving": "Saving...",
      "saved": "Saved",
      "save": "Save",
      "cancel": "Cancel",
      "addCard": "Add Card",
      "zipCode": "ZIP Code",
      "zipCodePlaceholder": "Enter ZIP Code",
      "zipCodeRequired": "Valid ZIP Code is Required",
      "zipCodeTooLong": "ZIP Code is too long",
      "fullName": "Full Name",
      "routingNumber": "Routing Number",
      "expirationPlaceholder": "MM/YY",
      "addErrorTitle": "Error adding payment method",
      "unknownError": "Unknown Error",
      "loadFormErrorTitle": "Unable to load payment form",
      "loadFormErrorBody": "Check your connection, then close and reopen the payment form to try again.",
      "editTitle": "Edit Payment Method",
      "addressLine1": "Address Line 1",
      "addressLine2": "Address Line 2",
      "city": "City",
      "state": "State",
      "zip": "ZIP",
      "country": "Country",
      "onFileTitle": "Edit Payment Method on File",
      "backupTitle": "Add Backup Payment Method"
    },
    "checkoutFlow": {
      "card": "Card",
      "cardHolderName": "Cardholder name",
      "cardNumber": "Card number",
      "expiryDate": "Expiry date",
      "securityCode": "Security code",
      "securityCodePlaceholder": "CVV",
      "expiryMonthPlaceholder": "MM",
      "expiryYearPlaceholder": "YY"
    },
    "errorBoundary": {
      "title": "Something went wrong when fetching your payment methods.",
      "body": "Refresh this page or try again later."
    },
    "notifications": {
      "fetchFailed": {
        "body": "We were unable to fetch your saved payment methods. Please try again."
      },
      "setDefaultSuccess": {
        "body": "Payment method was set as default"
      },
      "setDefaultFailed": {
        "body": "Oops! We couldn't set your payment method as default."
      },
      "deleteSuccess": {
        "body": "Payment method was deleted"
      },
      "deleteFailed": {
        "body": "Oops! We couldn't delete your payment method. Please try again."
      },
      "createFailed": {
        "body": "Oops! We couldn't create your payment method. Please double check your information and try again."
      },
      "paymentOnFileChanged": {
        "body": "Payment method on file was changed"
      },
      "updateOnFileFailed": {
        "body": "There was an issue updating your default payment information. Please try again later."
      },
      "createInstrumentSuccess": {
        "body": "New payment method created"
      },
      "addFailed": {
        "title": "Failed to add payment method",
        "body": "An error occurred while adding your payment method. Please try again."
      },
      "addFailedShort": {
        "body": "An error occurred while adding your payment method."
      }
    },
    "cardOnFileModal": {
      "cardAddedSuccess": "New credit card added",
      "addCardFailedTitle": "Failed to add card",
      "addCardFailedBody": "An error occurred while adding your card.",
      "defaultUpdatedSuccess": "Updated default credit card",
      "setDefaultFailedTitle": "Failed to set default",
      "setDefaultFailedBody": "We couldn't set your card as default. Please try again.",
      "missingProfileTitle": "Missing Profile Information",
      "missingProfileBody": "Our restaurant partners require us to have a form of payment on file before we can confirm reservations.",
      "bookingFeeNote": "Ande applies a {{percent}}% booking fee (nonrefundable) on any F&B minimum at the time of booking. Don't worry, you only get charged once you confirm.",
      "setDefaultTitle": "Set a card as default",
      "setDefaultSubtitle": "You can always change this later.",
      "back": "Back",
      "skipForNow": "Skip for now",
      "loading": "Loading...",
      "setDefaultCard": "Set a Default Card",
      "addCard": "Add a Card",
      "saving": "Saving...",
      "save": "Save"
    },
    "reservationPaymentsSection": {
      "title": "Payments",
      "noPaymentsDetected": "No Payments Detected",
      "emptyStateBody": "Any payments made through Ande will appear here. Add a receipt to be able to file an expense.",
      "paymentMethodsOnFile": "Payment Methods on File",
      "andeBookingFee": "Ande Booking Fee",
      "addPayment": "Add Payment",
      "uploadPaymentReceipt": "Upload Payment Receipt",
      "edit": "Edit"
    }
  },
  "onboarding": {
    "uploadPhoto": "Upload Photo",
    "diningFrequency": {
      "label": "How often do you organize dinner and events?",
      "placeholder": "Select an option",
      "options": {
        "AT_LEAST_THREE_PER_WEEK": "3+ per week",
        "ONCE_PER_WEEK": "1 per week",
        "ONCE_PER_MONTH": "1 per month",
        "ONCE_PER_QUARTER": "1 per quarter"
      }
    },
    "defaultOfficeLocation": "Default Office Location",
    "completeAccount": "Complete Account",
    "completingAccount": "Completing Account..."
  },
  "expenses": {
    "pageTitle": "Expenses",
    "fetchCheckError": {
      "title": "Something went wrong when fetching the check",
      "body": "Refresh this page or try again later."
    },
    "defaultTeCategory": "General",
    "notifications": {
      "deleteFileFailed": {
        "title": "Error deleting file",
        "body": "There was an issue deleting the file. Please try again"
      },
      "updatePaymentFailed": {
        "title": "Error updating payment",
        "body": "There was an issue updating your payment information. Please try again later."
      },
      "reservationNotFound": {
        "body": "We're unable to find the requested reservation. Please try again later."
      },
      "paymentServiceFailed": {
        "body": "There was an error with the payment service. Try refreshing the page"
      }
    }
  },
  "controlCenter": {
    "paymentApprovals": {
      "workflowList": {
        "department": "Department",
        "approver": "Approver",
        "edit": "Edit",
        "delete": "Delete",
        "empty": "No Approval Workflows found."
      },
      "purchaseOrderList": {
        "poNumber": "PO Number",
        "purpose": "Purpose",
        "budget": "Budget",
        "balance": "Balance",
        "status": "Status",
        "requiredApprover": "Required Approver",
        "preFunded": "PRE-FUNDED",
        "refPrefix": "ref:",
        "noApprover": "No",
        "edit": "Edit",
        "archive": "Archive",
        "empty": "No Purchase Orders found."
      }
    }
  },
  "assistantChat": {
    "error": "An error occurred.",
    "retry": "Retry",
    "archivedPlaceholder": "This chat is archived",
    "emptyHeading": "What are we planning?",
    "emptyBody": "I can help plan events, find venues and confirm reservations.",
    "exportDebugTranscript": "Export debug transcript",
    "downloadFileError": "Something went wrong while trying to open this file.",
    "downloadDocumentError": "This document couldn't be downloaded. You may not have permission to access it."
  },
  "integrations": {
    "partnerUserId": "Partner User ID",
    "partnerUserSecret": "Partner User Secret",
    "submitting": "Submitting...",
    "submit": "Submit",
    "notifications": {
      "saved": {
        "title": "Secrets Saved",
        "body": "Secrets saved successfully."
      },
      "saveFailed": {
        "body": "We were unable to save your secrets. Please try again later."
      }
    }
  },
  "hospitalityRewards": {
    "programPaused": {
      "tag": "Program paused",
      "title": "Ande Rewards is paused",
      "body": "We've paused the hospitality rewards program. Rewards already in your balance are yours to redeem. Please reach out to your account manager if you have any questions."
    },
    "keyDates": {
      "label": "Key dates",
      "lastAccrual": {
        "title": "Last day to earn rewards",
        "body": "Payments completed on or before {{date}} will still earn rewards. Payments completed after that date won't."
      },
      "redeemBy": {
        "title": "Redeem by {{date}}",
        "body": "Request a payout for your remaining balance by this date. Any unredeemed rewards will expire after {{monthDay}}."
      }
    },
    "notifications": {
      "payoutSuccess": {
        "title": "Payout requested",
        "body": "Check your email for your reward"
      },
      "payoutFailed": {
        "title": "Payout failed",
        "body": "Unable to request payout. Please try again."
      }
    },
    "balanceCard": {
      "balance": "Balance",
      "requestPayout": "Request Payout",
      "currentBalance": "Current Balance",
      "minimumPayout": "Minimum payout is {{amount}}."
    },
    "accruals": {
      "heading": "Completed Payments",
      "empty": "No completed payments yet",
      "withEventName": "Payment for {{eventName}} completed on\n{{completedDate}} - {{amount}}",
      "paymentOnly": "Payment for {{amount}} completed on {{completedDate}}"
    },
    "redemptions": {
      "heading": "Rewards Redemption History",
      "empty": "No redemptions yet",
      "payoutRequest": "{{amount}} payout request on {{date}}",
      "status": {
        "pending": "Pending",
        "successful": "Successful",
        "failed": "Failed"
      }
    },
    "agreementModal": {
      "title": "Ande Rewards",
      "earnCopy": "Every time a charge is completed through Ande, you earn rewards. This applies to corporate payments only.",
      "expiryCopy": "Credits expire after 1 year.",
      "windDownExpiryCopy": "Credits earned on or before {{cutoffDate}} expire at the end of {{deadlineDate}}.",
      "terms": "By redeeming these rewards, you agree to the <termsLink>terms and conditions</termsLink> of the Ande Rewards Program.",
      "termsLink": "terms and conditions"
    },
    "earnRateModal": {
      "title": "Earn cash for using Paylinks",
      "postTitle": "Every time a charge is completed through Ande you earn rewards. This applies to corporate payments only.",
      "paymentAmount": "Payment Amount",
      "youEarn": "You Earn",
      "disclaimer": "Your rewards have no value until redeemed. See terms for additional information.",
      "ok": "Ok"
    },
    "payoutConfirm": {
      "title": "Request payout?",
      "body": "Request a payout of {{amount}}? Your reward card will be sent to the email on file.",
      "cancel": "Cancel",
      "confirm": "Request Payout"
    }
  },
  "referrals": {
    "heading": "Refer your friends and earn a $100 gift card",
    "description": "There's no limit to the number of people you can refer to Ande. However, you will only get rewards if the person you invited completes a large group reservation. Read more about this in our <termsLink>Terms & Conditions</termsLink>",
    "termsLink": "Terms & Conditions",
    "steps": {
      "refer": {
        "title": "Refer a friend",
        "details": "Invite them via email."
      },
      "follow": {
        "title": "Follow their progress",
        "details": "Track your invitations below to ensure they were received."
      },
      "earn": {
        "title": "Earn a $100 gift card!",
        "details": "You can claim your reward once your referral has onboarded and then completes a <bold>large group reservation.</bold>",
        "bold": "large group reservation."
      }
    },
    "email": {
      "heading": "Refer via Email",
      "sendInvite": "Send Invite"
    },
    "list": {
      "heading": "Referred List",
      "redeemGiftCard": "Redeem Gift Card"
    },
    "status": {
      "rewardRedeemed": "REWARD REDEEMED",
      "completed": "COMPLETED",
      "accepted": "ACCEPTED",
      "sent": "SENT"
    },
    "notifications": {
      "sent": {
        "title": "Success!",
        "body": "Your referral was sent."
      },
      "sendError": {
        "title": "Error!",
        "body": "Issue creating invitation"
      },
      "claimSuccess": {
        "title": "Success!",
        "body": "Your reward has been redeemed. Your gift card will be emailed to you."
      },
      "genericError": {
        "title": "Error",
        "body": "There was an error with your referral. "
      }
    }
  },
  "rewards": {
    "notifications": {
      "loadFailed": {
        "title": "Failed to load data for rewards",
        "body": "Failed to load data for rewards. Please try again later."
      },
      "redemptionFailed": {
        "title": "Redemption failed"
      },
      "redemptionRangeError": "Enter a valid redemption amount between {{min}} and {{max}}.",
      "redemptionSent": {
        "title": "Redemption request sent!",
        "body": ""
      },
      "redemptionSubmitFailed": "Unable to submit your redemption request. Please try again.",
      "optInSuccess": {
        "title": "Success!",
        "body": "Your account has been enabled for rewards."
      },
      "claimSuccess": {
        "title": "Success!",
        "body": "Your reward has been redeemed. Your gift card will be emailed to you."
      }
    },
    "legacy": {
      "monthRewards": "{{month}} Rewards",
      "tierLabels": {
        "level1": "Level 1",
        "level2": "Level 2",
        "level3": "Level 3",
        "referral": "Referral"
      },
      "pointsValue": "{{count}} pts",
      "pointsEarned": "{{count}} Points Earned",
      "pointsPending": "{{count}} Points Pending",
      "largeGroupDining": "Large Group Dining",
      "regularDining": "Regular Dining",
      "complete": "{{count}} Complete",
      "pending": "{{count}} Pending",
      "forPointsTotal": "for <strong>{{points}} points</strong> total",
      "history": {
        "heading": "History",
        "empty": "Nothing here yet.",
        "earned": "Earned",
        "pending": "Pending",
        "review": "Review",
        "carriedOver": "Carried over from last month",
        "points_one": "+{{count}} pt",
        "points_other": "+{{count}} pts"
      },
      "levelGoals": "Level Goals",
      "levelGoal": "To earn your {{tier}} reward, you must earn <strong>{{points}}</strong> total {{pointsLabel}} within the month for a <strong>{{value}}</strong> gift card.",
      "point_one": "point",
      "point_other": "points",
      "pointAbbrev_one": "PT",
      "pointAbbrev_other": "PTS",
      "levelGoalsFooter": "Points are generated by completed events booked through the Ande platform. Upon completion of the level, you can claim your gift card reward from the \"Claim Rewards\" section of this page. Unclaimed rewards will expire 12 months after they've been granted, and reward levels will reset every calendar month.",
      "sections": {
        "largeGroup": {
          "title": "Large Group Dining",
          "description": "A large group reservation qualifies as any completed booking which involves booking a private room, buyout or adhering to a minimum spend. These reservations are worth"
        },
        "regular": {
          "title": "General Dining",
          "description": "A regular reservation qualifies as any completed booking in a general dining area of a restaurant. These reservations are worth"
        },
        "review": {
          "title": "Leave a review",
          "description": "Leave a review for the venue after completing an event and earn an extra"
        },
        "pointsHeaderNoPromo": "<current>+{{currentPoints}}</current><abbrev> {{currentAbbrev}}</abbrev>",
        "pointsHeaderPromo": "<strikethrough>+{{originalPoints}} {{originalAbbrev}}</strikethrough><current>+{{currentPoints}}</current><abbrev> {{currentAbbrev}}</abbrev>",
        "pointsDetailNoPromo": "{{description}} <strong>{{currentPoints}}</strong> {{pointsLabel}}.",
        "pointsDetailPromo": "{{description}} <strikethrough>{{originalPoints}}</strikethrough> <strong>{{currentPoints}}</strong> {{pointsLabel}}."
      },
      "promotion": {
        "double": "Double Your Rewards!",
        "triple": "Triple Your Rewards!",
        "multiplier": "{{multiplier}}x Your Rewards!",
        "defaultTitle": "Earn More Points Towards Rewards!",
        "maximize": "Maximize your rewards with exclusive {{rate}} points on every reservation.",
        "earnSingleDay": "Earn $100 for every large group booking made on {{date}}.",
        "earnRange": "Earn $100 for every large group booking made between {{startDate}} and {{endDate}}.",
        "bonus": "bonus"
      }
    },
    "optIn": {
      "cardAlt": "Ande Rewards Card",
      "brand": "Ande Rewards",
      "headline": "Personal points for work reservations",
      "description": "Book a dinner for your executive or your team. You get points for completed reservations, then redeem your points for gift cards every month.",
      "enable": "Enable Rewards",
      "enabling": "Enabling Rewards...",
      "terms": "By enabling you agree to the <termsLink>Terms & Conditions</termsLink> of the Ande Rewards program.",
      "termsLink": "Terms & Conditions",
      "termsRequired": "You must agree to the terms and conditions."
    },
    "claimTable": {
      "heading": "Claim Rewards",
      "expiryNotice": "Unclaimed rewards will expire 12 months after they've been granted, and reward levels will reset every calendar month.",
      "rewardLabel": "{{date}} {{tier}} Reward",
      "status": {
        "claimed": "Claimed",
        "migrated": "Migrated",
        "expired": "Expired",
        "claimAmount": "Claim {{value}}"
      },
      "empty": {
        "title": "No Rewards Earned Yet",
        "body": "Complete a level and your Rewards will be able to be claimed here."
      }
    },
    "claimModal": {
      "title": "Redeem {{amount}} Gift Card",
      "titleNoAmount": "Redeem Gift Card",
      "postTitle": "Select a venue and we'll send you the appropriate gift card via email for that hospitality group.",
      "searchPlaceholder": "Search for a venue",
      "loadingVenues": "Loading venues...",
      "noVenuesFound": "No venues Found",
      "noVenuesAvailable": "No venues available",
      "tryDifferentSearch": "Try searching for a different venue",
      "noEligibleVenues": "No eligible venues found for gift cards",
      "loadError": "Error loading venues",
      "tryAgainLater": "Please try again later",
      "selectVenueAria": "Select {{name}}",
      "claimReward": "Claim Reward",
      "claimingReward": "Claiming Reward..."
    },
    "enterprise": {
      "pendingAmount": "+ {{amount}} pending",
      "balance": {
        "title": "Balance",
        "hasEarned": "You have unclaimed rewards. Redeem them anytime as a gift card.",
        "noneAvailable": "You have no rewards available. Complete reservations to earn them.",
        "redeemNow": "Redeem now"
      },
      "earnRatesModal": {
        "title": "Ande Rewards earning rates",
        "eventSpend": "Event spend",
        "anyVenue": "Any venue",
        "partnerVenue": "Partner venue",
        "disclaimer": "Reward amounts shown are estimates based on typical bookings in each spend range. Final Ande Rewards earned may vary depending on the venue and your event total."
      },
      "howToEarn": {
        "heading": "How to earn Ande Rewards?",
        "step1": {
          "label": "STEP 1",
          "title": "Book a reservation",
          "description": "Search and compare venues through Ande. Your estimated reward is shown upfront."
        },
        "step2": {
          "label": "STEP 2",
          "title": "Complete the reservation",
          "description": "Once your event takes place, your Ande Rewards is added to your balance automatically."
        },
        "step3": {
          "label": "STEP 3",
          "title": "Redeem once you've earned {{min}}",
          "description": "Request a redemption anytime you've reached {{min}}. You'll get a confirmation email when your reward is on its way."
        },
        "partnerTitle": "Earn more at partner venues",
        "partnerDescription": "Partner venues unlock a higher reward rate. Look for the Ande Rewards badge when browsing to maximize your Ande Rewards.",
        "seeEarnRates": "See earn rates"
      },
      "history": {
        "heading": "History",
        "empty": "Nothing here yet.",
        "loadFailed": "We couldn't load your history. Refresh the page to try again.",
        "filters": {
          "label": "Filter history",
          "all": "All",
          "earned": "Earned",
          "redeemed": "Redeemed"
        },
        "earned": "Earned",
        "pending": "Pending",
        "rewardsRedeemed": "Rewards redeemed",
        "giftCardOn": "Gift card · {{date}}",
        "balance": "Balance {{amount}}"
      },
      "redemptionStatus": {
        "redeemed": "Redeemed",
        "failed": "Failed",
        "cancelled": "Cancelled",
        "requested": "Requested"
      },
      "faq": {
        "heading": "FAQs",
        "programBasics": {
          "title": "Program Basics",
          "whatIsAndeRewards": {
            "q": "What is Ande Rewards?",
            "a": "A program that rewards corporate bookers with a reward for qualifying large-group dining bookings made on Ande. Reward value is based on the size of the booking and the venue."
          },
          "whoIsEligible": {
            "q": "Who is eligible?",
            "a": "Any individual booker on a corporate account who books a qualifying large-group dining event."
          },
          "qualifyingBooking": {
            "q": "What counts as a \"qualifying\" booking?",
            "a": "A confirmed, large-group corporate dining booking made directly on the Ande platform. Qualifying bookings are reflected in the product experience."
          },
          "costToJoin": {
            "q": "Is there a cost to join, or do I need to sign up?",
            "a": "Your balance starts accruing automatically the first time a booking is confirmed."
          }
        },
        "earning": {
          "title": "Earning Rewards",
          "howMuch": {
            "q": "How much can I earn?",
            "a": "The reward amount depends on the venue and the size of your booking. You'll always see the estimated dollar amount you'll earn before you complete your booking."
          },
          "whenReleased": {
            "q": "When do I actually get the reward?",
            "a": "The reward is released once your booking is complete."
          },
          "virtualConcierge": {
            "q": "Does this apply to bookings made through a virtual concierge?",
            "a": "Yes — self-serve and virtual-concierge bookings both qualify."
          }
        },
        "balance": {
          "title": "Balance & Accrual",
          "pendingVsConfirmed": {
            "q": "What's the difference between \"pending\" and \"confirmed\" balance?",
            "a": "Pending is reward tied to a transaction still processing; confirmed is a reward that's finished processing and ready to redeem."
          },
          "whereSeeBalance": {
            "q": "Where can I see my balance?",
            "a": "At the top of the product, and in your dedicated Rewards Balance Portal."
          },
          "history": {
            "q": "Can I see a history of what I've earned?",
            "a": "The balance portal includes a qualification history and a full ledger (pending, confirmed, redeemed)."
          }
        },
        "redemption": {
          "title": "Redemption",
          "howRedeem": {
            "q": "How do I redeem my rewards?",
            "a": "Go to the Rewards Balance Portal, review your balance, and select redeem."
          },
          "minimum": {
            "q": "Is there a minimum balance to redeem?",
            "a": "Yes — {{min}}."
          },
          "whatYouGet": {
            "q": "What do I get when I redeem?",
            "a": "A single-use virtual card issued through our redemption partner, Tremendous."
          },
          "firstTime": {
            "q": "What happens the first time I redeem?",
            "a": "You'll provide your contact information so Tremendous can issue your card."
          },
          "confirmation": {
            "q": "Will I get a confirmation?",
            "a": "Yes — you'll get an email when you initiate redemption, and another once it's completed and your card is issued."
          },
          "anytime": {
            "q": "Can I redeem anytime once I hit {{min}}?",
            "a": "Yes, there's no waiting/vesting period."
          }
        },
        "policies": {
          "title": "Policies",
          "expire": {
            "q": "Do rewards expire?",
            "a": "Points expire one year after accrual."
          },
          "taxable": {
            "q": "Are rewards taxable?",
            "a": "Gift cards are considered taxable. If program recipients receive more than the reporting threshold, Tremendous will prompt for W-9 collection before redemption."
          }
        }
      },
      "redeem": {
        "title": "Redeem Ande Rewards",
        "amountLabel": "Amount to redeem",
        "rangeHint": "You can redeem between {{min}} and {{max}} per request. Any remaining balance stays in your account for your next redemption.",
        "tremendousHint": "We'll review your request and send you a gift card link via <tremendousLink>tremendous.com</tremendousLink>.",
        "giftCardHint": "Once claimed, your gift card can be used however you like; it's not linked to Ande.",
        "terms": "I agree to the <termsLink>terms and conditions</termsLink> of the Ande Rewards Program.",
        "termsLink": "terms and conditions",
        "redeeming": "Redeeming...",
        "redeemAmount": "Redeem {{amount}}"
      }
    }
  }
}
